import React from 'react';
import {observable, action, computed, makeObservable} from 'mobx';
import {observer} from 'mobx-react';
import s from '../s';
import ModalSimple from '../../global/modal-simple';
import InfoIcon from './shared/info-icon';

@observer
export default class EngravedPlate extends React.Component {
    @observable ep1: string;
    @observable ep2: string;
    @observable ep3: string;
    @observable ep4: string;
    @observable ep5: string;
    @observable ep6: string;
    @observable ep7: string;
    @observable ep8: string;
    @observable ep9: string;
    @observable ep10: string;
    @observable collapsed: boolean = true;

    constructor(props) {
        super(props);
        this.collapseToggle = this.collapseToggle.bind(this);
        makeObservable(this);
    }

    @action
    collapseToggle = async () => {
        this.collapsed = !this.collapsed;
    };

    @computed get canCollapse(): boolean {
        return s.pcs.is_caf || window.innerWidth < 960;
    }

    @action
    ep_color_change = async (e: any) => {
        s.pcs.ep_id_view = parseInt(e.target.value, 10);
        if (s.pcs.ep_id > 0) {
            s.pcs.ep_id = s.pcs.ep_id_view;
            s.ui.doRender = true;
            s.ui.update_pricing = true;
            s.pulse();
        }
    };

    @action
    ep_add = async (e: any) => {
        s.pcs.ep_id = s.pcs.ep_id_view;
        s.ui.doRender = true;
        s.pcs.ep1  = this.ep1;
        s.pcs.ep2  = this.ep2;
        s.pcs.ep3  = this.ep3;
        s.pcs.ep4  = this.ep4;
        s.pcs.ep5  = this.ep5;
        s.pcs.ep6  = this.ep6;
        s.pcs.ep7  = this.ep7;
        s.pcs.ep8  = this.ep8;
        s.pcs.ep9  = this.ep9;
        s.pcs.ep10 = this.ep10;
        s.pcs.lino_base_name = '';
        s.pcs.lino_id = -1;
        s.ui.update_pricing = true;

        if (s.pcs.ep_id === 1099) {
            s.pcs.ins_black_allowed = true;
            s.pcs.ins_gold_allowed = true;
            s.pcs.ins_silver_allowed = true;
        } else if (s.pcs.ep_id === 39) {
            s.pcs.ins_black_allowed = false;
            s.pcs.ins_gold_allowed = false;
            s.pcs.ins_silver_allowed = true;
        } else if (s.pcs.ep_id === 37) {
            s.pcs.ins_black_allowed = false;
            s.pcs.ins_gold_allowed = true;
            s.pcs.ins_silver_allowed = false;
        }

        s.pulse();
    };

    @action
    ep_remove = async (e: any) => {
        if (s.pcs.ep_id > 0) {
            s.pcs.ep_id = 0;
            s.ui.update_pricing = true;
            s.ui.doRender = true;
            s.pulse();
        }
    };

    @action
    ep_change_text = async () => {
        s.pcs.ep1  = this.ep1;
        s.pcs.ep2  = this.ep2;
        s.pcs.ep3  = this.ep3;
        s.pcs.ep4  = this.ep4;
        s.pcs.ep5  = this.ep5;
        s.pcs.ep6  = this.ep6;
        s.pcs.ep7  = this.ep7;
        s.pcs.ep8  = this.ep8;
        s.pcs.ep9  = this.ep9;
        s.pcs.ep10 = this.ep10;
    };

    @computed get getColorText(): string {
        switch (s.pcs.ep_id) {
            case 37:
                return `Gold`;
            case 39:
                return `Silver`;
            case 1099:
                return `Black`;
            case 33146:
                return `White`;

            default:
                return '';
        }
    }

    @computed get getColorTextLower(): string {
        if (s.ui.name_moulding.toLowerCase().includes('silver') || !s.pcs.ins_gold_allowed) {
            switch (s.pcs.ep_id) {
                case 37:
                    return `gold`;
                case 39:
                    return `silver`;
                case 1099:
                    return `black`;
                case 33146:
                    return `white`;

                default:
                    return 'silver';
            }
        } else {
            switch (s.pcs.ep_id) {
                case 37:
                    return `gold`;
                case 39:
                    return `silver`;
                case 1099:
                    return `black`;
                case 33146:
                    return `white`;

                default:
                    return 'gold';
            }
        }
    }

    @computed get getImage(): string {

        switch (s.pcs.ep_id) {
            case 37:
                    return `https://${s.Portal.CDNDomain}/images/entities/engravedplate/ep_gold_original_engravedplate.png`;
                case 39:
                    return `https://${s.Portal.CDNDomain}/images/entities/engravedplate/ep_silver_original_engravedplate.png`;
                case 1099:
                    return `https://${s.Portal.CDNDomain}/images/entities/engravedplate/ep_black_original_engravedplate.png`;
                case 33146:
                    return `https://${s.Portal.CDNDomain}/images/cached/general/ep_white_original_engravedplate.png`;

            default:
                break;
        }

        return `https://${s.Portal.CDNDomain}/images/entities/engravedplate/ep_gold_original_engravedplate.png`;
    }

    render() {
        if (!s.ui.show_cust || !s.prod.EngravedPlateStatusID || s.prod.EngravedPlateStatusID < 1) {
            return;
        }

        return (
            <div
                className="gray-box ep"
                style={{padding: 0}}
            >
                <ModalSimple
                    id="modal-sample-ep"
                    title="Engraved Plate Information"
                    maxWidth="600px"
                >
                    <div>
                        <ul>
                            {s.prod.EngravedPlateStatusID === 0 && <li>This product does not allow an engraved plate</li>}
                            {s.prod.EngravedPlateStatusID === 1 && <li>This product requires a gold engraved plate</li>}
                            {s.prod.EngravedPlateStatusID === 2 && <li>This product requires a silver engraved plate</li>}
                            {s.prod.EngravedPlateStatusID === 3 && <li>This product allows a gold engraved plate</li>}
                            {s.prod.EngravedPlateStatusID === 4 && <li>This product allows a silver engraved plate</li>}
                            {s.prod.EngravedPlateStatusID === 5 && <li>This product allows a gold or silver engraved plate</li>}
                            {s.prod.EngravedPlateStatusID === 6 && <li>This product requires a black engraved plate</li>}
                            {s.prod.EngravedPlateStatusID === 7 && <li>This product allows a black engraved plate</li>}
                            {s.prod.EngravedPlateStatusID === 8 && <li>This product requires a white engraved plate</li>}
                            {s.prod.EngravedPlateStatusID === 9 && <li>This product allows a white engraved plate</li>}
                            <li>Enter up to 30 characters per line</li>
                            <li>You may have 1, 2, or 3 lines centered on the engraved plate</li>
                            <li>Dimensions: 3" X 1"</li>
                            <li>If you do not provide text, a plate will not be included with your order</li>
                        </ul>
                        <div>
                            <b>Example engraved plate:</b>
                        </div>
                        <img
                            src={`https://${s.Portal.CDNDomain}/images/products/full/80049pid25402.png`}
                            alt="Example engraved plate"
                            aria-label="Example engraved plate"
                        ></img>
                    </div>
                </ModalSimple>
                <div className={this.canCollapse && s.pcs.is_caf ? '' : ''}>
                    <div
                        style={{
                            paddingLeft: 12,
                            paddingRight: 12,
                            paddingTop: 0,
                            paddingBottom: 0,
                            position: 'relative',
                        }}
                    >
                        <div
                            role={this.canCollapse ? 'button' : undefined}
                            tabIndex={this.canCollapse ? 0 : undefined}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    e.currentTarget.click();
                                }
                            }}
                            className="d-none d-xl-block toggle-bs"
                            data-bs-toggle={this.canCollapse ? 'collapse' : ''}
                            data-bs-target="#ep-inner"
                            aria-expanded={this.canCollapse ? false : undefined}
                            aria-controls={this.canCollapse ? 'ep-inner' : undefined}
                        >
                            <div className="cust-desktop-head">
                                <span>Engraved Plate: </span>
                                <span>{this.getColorText}</span>
                            </div>
                        </div>

                        <div
                            role="button"
                            tabIndex={0}
                            onKeyDown={e => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    e.currentTarget.click();
                                }
                            }}
                            className="d-block d-xl-none toggle-bs"
                            data-bs-toggle={this.canCollapse ? 'collapse' : ''}
                            data-bs-target="#ep-inner"
                            aria-expanded={this.canCollapse ? false : undefined}
                            aria-controls={this.canCollapse ? 'ep-inner' : undefined}
                        >
                            <div className="cust-flex-head">
                                <div>
                                    <div
                                        className="header-std flexer cust-flex2"
                                        style={{paddingRight: '0.25rem'}}
                                    >
                                        Engraved Plate
                                    </div>
                                    <div className="cust-flex2">{this.getColorText}</div>
                                </div>
                                <div>
                                    {s.pcs.ep_id > 0 && (
                                        <img
                                            className="th-h"
                                            src={this.getImage}
                                            alt="Engraved Plate Thumbnail"
                                            style={{height: 48, width: 'auto'}}
                                        />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        id="ep-inner"
                        className={this.canCollapse ? 'collapse' : ''}
                        style={{
                            padding: '0 12px',
                        }}
                    >
                        <div>
                            <div className={`ep-container ${this.getColorTextLower}`}>
                                {s.prod.EngravedPlateLines > 0 && (
                                    <div>
                                        <input
                                            type="text"
                                            className="ep-text"
                                            maxLength={30}
                                            aria-label="Line 1 of the engraved plate"
                                            placeholder='Line 1'
                                            id='ep-1'
                                            onChange={e => {
                                                this.ep1 = e.target.value;
                                                this.ep_change_text();
                                            }}
                                        />
                                    </div>
                                )}
                                {s.prod.EngravedPlateLines > 1 && (
                                    <div>
                                        <input
                                            type="text"
                                            className="ep-text"
                                            maxLength={30}
                                            aria-label="Line 2 of the engraved plate"
                                            placeholder='Line 2'
                                            id='ep-2'
                                            onChange={e => {
                                                this.ep2 = e.target.value;
                                                this.ep_change_text();
                                            }}
                                        />
                                    </div>
                                )}
                                {s.prod.EngravedPlateLines > 2 && (
                                    <div>
                                        <input
                                            type="text"
                                            className="ep-text"
                                            maxLength={30}
                                            aria-label="Line 3 of the engraved plate"
                                            placeholder='Line 3'
                                            id='ep-3'
                                            onChange={e => {
                                                this.ep3 = e.target.value;
                                                this.ep_change_text();
                                            }}
                                        />
                                    </div>
                                )}
                            </div>

                            <div className="ep-option">
                                {s.prod.EngravedPlateStatusID === 5 && (
                                    <div className="ep-color">
                                        <select
                                            onChange={this.ep_color_change}
                                            aria-label="Select engraved plate color"
                                        >
                                            {s.pcs.ins_gold_allowed && <option value="37">Gold</option>}
                                            {s.pcs.ins_silver_allowed && <option value="39">Silver</option>}
                                        </select>
                                    </div>
                                )}
                                {s.prod.EngravedPlateStatusID !== 1 && s.prod.EngravedPlateStatusID !== 2 && s.prod.EngravedPlateStatusID !== 6 && s.prod.EngravedPlateStatusID !== 8 && (
                                    <div className="ep-toggle">
                                        {(!s.pcs.ep_id || s.pcs.ep_id <= 0) && (
                                            <button
                                                type="button"
                                                aria-label="Add engraved plate to product"
                                                onClick={this.ep_add}
                                            >
                                                Add Engraved Plate
                                            </button>
                                        )}
                                        {s.pcs.ep_id > 0 && (
                                            <button
                                                type="button"
                                                aria-label="Remove engraved plate from product"
                                                onClick={this.ep_remove}
                                            >
                                                Remove Engraved Plate
                                            </button>
                                        )}
                                    </div>
                                )}
                            </div>

                            <div className="ep-link mb-1">
                                View information about engraved plates
                                <InfoIcon
                                    id="modal-sample-ep"
                                    ariaLabel="View more information about engraved plates"
                                    useMargin={true}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
